import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const ManageLevelsModal = ({ show, onHide, indexName, selectedLevels, levelsToDelete, handleLevelCheckboxChange, handleDeleteLevels }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Manage Levels for {indexName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {indexName && (
          <div>
            <h6>Levels (CE/PE)</h6>
            {selectedLevels[indexName]?.ceLevels.length || selectedLevels[indexName]?.peLevels.length ? (
              (() => {
                const { ceLevels, peLevels } = selectedLevels[indexName];
                const pairedLevels = [];
                ceLevels.forEach((ce) => {
                  const pe = peLevels.find((p) => p.level === -ce.level);
                  if (pe) {
                    pairedLevels.push({
                      ceLevel: ce.level,
                      peLevel: pe.level
                    });
                  } else {
                    pairedLevels.push({
                      ceLevel: ce.level,
                      peLevel: null
                    });
                  }
                });
                peLevels.forEach((pe) => {
                  if (!ceLevels.find((c) => c.level === -pe.level)) {
                    pairedLevels.push({
                      ceLevel: null,
                      peLevel: pe.level
                    });
                  }
                });
                pairedLevels.sort((a, b) => (a.ceLevel || 0) - (b.ceLevel || 0));
                return pairedLevels.map(({ ceLevel, peLevel }, i) => {
                  const ceText = ceLevel !== null ? (ceLevel >= 0 ? `+${ceLevel}` : ceLevel) : '--';
                  const peText = peLevel !== null ? (peLevel >= 0 ? `+${peLevel}` : peLevel) : '--';
                  const levelText = `${ceText}/${peText}`;
                  return (
                    <Form.Check
                      key={`level-${i}`}
                      type="checkbox"
                      label={levelText}
                      checked={ceLevel !== null ? levelsToDelete.ce.includes(ceLevel) : levelsToDelete.pe.includes(peLevel)}
                      onChange={(e) => {
                        if (ceLevel !== null) {
                          handleLevelCheckboxChange('ce', ceLevel, e.target.checked);
                        }
                        if (peLevel !== null) {
                          handleLevelCheckboxChange('pe', peLevel, e.target.checked);
                        }
                      }}
                    />
                  );
                });
              })()
            ) : (
              <p>No levels available</p>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={() => handleDeleteLevels(indexName, levelsToDelete)}
          disabled={levelsToDelete.ce.length === 0 && levelsToDelete.pe.length === 0}
          className="me-2"
        >
          Delete Selected
        </Button>
        <Button
          variant="secondary"
          onClick={onHide} // Fix: Only call onHide
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManageLevelsModal;